import React, { useState } from 'react';
import * as OTPAuth from 'otpauth';
import { getDoc, doc } from 'firebase/firestore';
import { db, auth } from '../firebase/config';
import '../styles/twofa.css';

function TwoFactorVerify({ onVerified, onCancel }) {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleVerify = async () => {
    setError('');
    setLoading(true);

    if (code.length !== 6) {
      setError('Please enter 6-digit code');
      setLoading(false);
      return;
    }

    try {
      const user = auth.currentUser;
      const userDoc = await getDoc(doc(db, 'users', user.uid));
      
      if (!userDoc.exists()) {
        setError('User configuration not found');
        setLoading(false);
        return;
      }

      const secret = userDoc.data().totpSecret;
      
      // Create TOTP instance with saved secret
      const totp = new OTPAuth.TOTP({
        issuer: 'StoreManager',
        label: user.email,
        algorithm: 'SHA1',
        digits: 6,
        period: 30,
        secret: OTPAuth.Secret.fromBase32(secret)
      });
      
      // Verify code
      const delta = totp.validate({ token: code, window: 1 });
      
      if (delta !== null) {
        onVerified();
      } else {
        setError('Invalid code. Please try again.');
        setCode('');
      }
    } catch (err) {
      console.error('Verification error:', err);
      setError('Verification failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    await auth.signOut();
    onCancel();
  };

  return (
    <div className="twofa-container">
      <div className="twofa-box">
        <h2 className="twofa-title">🔐 Two-Factor Authentication</h2>
        <p className="twofa-subtitle">Enter the code from your authenticator app</p>

        <div className="verify-section">
          {error && <div className="twofa-error">{error}</div>}

          <input
            type="text"
            className="verify-input"
            placeholder="000000"
            maxLength="6"
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
            disabled={loading}
            autoFocus
          />

          <div className="twofa-actions">
            <button 
              className="btn-skip" 
              onClick={handleLogout}
              disabled={loading}
            >
              Cancel
            </button>
            <button 
              className="btn-verify" 
              onClick={handleVerify}
              disabled={code.length !== 6 || loading}
            >
              {loading ? 'Verifying...' : '✓ Verify'}
            </button>
          </div>

          <div className="verify-hint">
            Open your authenticator app and enter the 6-digit code
          </div>
        </div>
      </div>
    </div>
  );
}

export default TwoFactorVerify;